import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Equipo.css';
import './MobileNav.css';
import logo from '../assets/logoblanco-def.png';
import favicon from '../assets/favicon.png';
import { useCart } from '../context/CartContext';
import { useNavbarScroll } from '../hooks/useNavbarScroll';
import Footer from './Footer';
import Cart from './Cart';
import MobileNav from './MobileNav';

// Import wine curve decorative elements
import winecurv01 from '../assets/winecurv_15_1-Convertido-01.png';
import winecurv02 from '../assets/winecurv_15_1-Convertido-02.png';
import winecurv04 from '../assets/winecurv_15_1-Convertido-04.png';
import winecurv05 from '../assets/winecurv_15_1-Convertido-05.png';
import winecurv06 from '../assets/winecurv_15_1-Convertido-06.png';
import winecurv14 from '../assets/winecurv_15_1-Convertido-14.png';
import winecurv17 from '../assets/winecurv_15_1-Convertido-17.png';
import winecurv18 from '../assets/winecurv_15_1-Convertido-18.png';
import winecurv22 from '../assets/winecurv_15_1-Convertido-22.png';
import winecurv24 from '../assets/winecurv_15_1-Convertido-24.png';
import winecurv25 from '../assets/winecurv_15_1-Convertido-25.png';
import winecurv27 from '../assets/winecurv_15_1-Convertido-27.png';

const departamentos = [
  {
    id: 'directorio',
    title: 'Directorio',
    members: [
      {
        name: 'Jaime Rosés',
        role: 'DIRECTOR',
        image: require('../assets/Jaime.png')
      },
      {
        name: 'Walter Rosés',
        role: 'DIRECTOR',
        image: require('../assets/Walter.jpg')
      },
      {
        name: 'Pablo Rosés',
        role: 'DIRECTOR',
        image: require('../assets/Pablo.jpeg')
      }
    ]
  },
  {
    id: 'enologico',
    title: 'Departamento Enológico',
    members: [
      {
        name: 'Eduardo Rosés',
        role: 'LIC. ENOLOGÍA',
        image: require('../assets/Eduardo.jpeg')
      },
      {
        name: 'Martín Rosés',
        role: 'LIC. ENOLOGÍA',
        image: require('../assets/Martin2.jpg')
      },
      {
        name: 'Laura Villar',
        role: 'ENÓLOGA',
        image: require('../assets/Laura.jpeg')
      }
    ]
  },
  {
    id: 'comercial',
    title: 'Departamento Comercial',
    members: [

      {
        name: 'Walter Rosés',
        role: 'LIC. COMERCIO EXTERIOR',
        image: require('../assets/Waltito.jpeg')
      }
    ]
  },
  {
    id: 'vitivinicola',
    title: 'Departamento Vitivinícola',
    members: [
      {
        name: 'Diego Blangero',
        role: 'TEC: AGROPECUARIO',
        image: require('../assets/diego2.jpg')
      }

    ]
  },
  {
    id: 'ventas',
    title: 'Departamento Administrativo',
    members: [
      {
        name: 'Fernando Benapres',
        role: 'ADMINISTRACIÓN',
        image: require('../assets/Fernando.jpeg')
      },
      {
        name: 'Alexis Odero',
        role: 'ADMINISTRACIÓN',
        image: require('../assets/Alexis.jpeg')
      },
      {
        name: 'Juan Pablo Rosés',
        role: 'ADMINISTRACIÓN',
        image: require('../assets/Juan Pablo.jpeg')
      },
      {
        name: 'Andrea Fernández',
        role: 'SECRETARÍA',
        image: require('../assets/Andrea.jpeg')
      },
      {
        name: 'Cristian Rosés',
        role: 'ADMINISTRACIÓN',
        image: require('../assets/Cristian.jpeg')
      }
    ]
  },
  {
    id: 'publicidad',
    title: 'Departamento de Marketing',
    members: [
      {
        name: 'Fiorella Rosés',
        role: 'Lic. en Publicidad',
        image: require('../assets/Fiorella.jpeg')
      }
    ]
  }
];

const Equipo = () => {
  const navigate = useNavigate();
  const { toggleCart, getTotalItems } = useCart();
  const heroRef = useRef(null);
  const deptScrollRefs = useRef({});
  const [navReady, setNavReady] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { hidden: navbarHidden, compact: navbarCompact } = useNavbarScroll();

  const scrollDeptCarousel = (deptId, direction) => {
    const el = deptScrollRefs.current[deptId];
    if (!el) return;
    const step = Math.min(280, el.clientWidth * 0.85);
    el.scrollBy({ left: direction * step, behavior: 'smooth' });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const timer = setTimeout(() => setNavReady(true), 100);
    
    // Intersection Observer para las fotos de los miembros (bidireccional)
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    };
    
    const memberObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('member-photo-visible');
        } else {
          entry.target.classList.remove('member-photo-visible');
        }
      });
    }, observerOptions);
    
    // Intersection Observer para los títulos (bidireccional)
    const titleObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('title-visible');
        } else {
          entry.target.classList.remove('title-visible');
        }
      });
    }, { threshold: 0.3, rootMargin: '0px' });
    
    // Esperar a que se rendericen los elementos
    setTimeout(() => {
      const cards = document.querySelectorAll('.member-card');
      cards.forEach(card => memberObserver.observe(card));
      
      const titles = document.querySelectorAll('.department-title');
      titles.forEach(title => titleObserver.observe(title));
    }, 100);
    
    return () => {
      clearTimeout(timer);
      memberObserver.disconnect();
      titleObserver.disconnect();
    };
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="equipo-page">
      {/* Floating wine decorations (clipped to avoid extra scroll below footer) */}
      <div className="wine-decor-wrapper">
        <img src={winecurv01} alt="" className="wine-decor wine-decor-1" />
        <img src={winecurv02} alt="" className="wine-decor wine-decor-2" />
        <img src={winecurv06} alt="" className="wine-decor wine-decor-3" />
        <img src={winecurv18} alt="" className="wine-decor wine-decor-4" />
        <img src={winecurv22} alt="" className="wine-decor wine-decor-5" />
        <img src={winecurv25} alt="" className="wine-decor wine-decor-6" />
        <img src={winecurv04} alt="" className="wine-decor wine-decor-7" />
        <img src={winecurv17} alt="" className="wine-decor wine-decor-8" />
        <img src={winecurv24} alt="" className="wine-decor wine-decor-9" />
        <img src={winecurv05} alt="" className="wine-decor wine-decor-10" />
        <img src={winecurv14} alt="" className="wine-decor wine-decor-11" />
        <img src={winecurv27} alt="" className="wine-decor wine-decor-12" />
      </div>

      {/* Navigation */}
      <nav className={`equipo-navbar${navReady ? ' equipo-nav-ready' : ''}${navbarHidden ? ' navbar-hidden' : ''}${navbarCompact ? ' navbar-compact' : ''}`}>
        <div className="equipo-navbar-content">
          <div className="navbar-left">
            <button onClick={() => navigate('/')} className="nav-link-equipo">INICIO</button>
            <button onClick={() => navigate('/equipo')} className="nav-link-equipo">EQUIPO</button>
            <button onClick={() => navigate('/bodegas')} className="nav-link-equipo">BODEGAS</button>
          </div>
          <div className="navbar-center">
            <button onClick={() => navigate('/')}>
              <img src={logo} alt="Rosés Wines" className="nav-logo-equipo" />
            </button>
          </div>
          <div className="navbar-right">
            <button onClick={() => navigate('/historia')} className="nav-link-equipo">HISTORIA</button>
            <button onClick={() => navigate('/kit-de-marca')} className="nav-link-equipo">KIT DE MARCA</button>
            <button onClick={() => navigate('/#tienda')} className="nav-link-equipo">TIENDA</button>
            <button className="nav-link-equipo cart-equipo" onClick={toggleCart}>
              <span className="cart-icon">🛒</span>
              {getTotalItems() > 0 && (
                <span className="cart-badge-equipo">{getTotalItems()}</span>
              )}
            </button>
          </div>
          <button
            type="button"
            className={`mobile-nav-hamburger${mobileMenuOpen ? ' open' : ''}`}
            onClick={() => setMobileMenuOpen((o) => !o)}
            aria-expanded={mobileMenuOpen}
            aria-label="Menú"
          >
            <span className="mobile-nav-hamburger-line" />
            <span className="mobile-nav-hamburger-line" />
            <span className="mobile-nav-hamburger-line" />
          </button>
        </div>
      </nav>

      <MobileNav open={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />

      {/* Hero Section */}
      <section className="equipo-hero" ref={heroRef}>
        <div className="equipo-hero-icon">
          <img src={favicon} alt="Rosés Icon" />
        </div>
        <h1 className="equipo-hero-title">
          NUESTRO<br />
          EQUIPO
        </h1>
        <p className="equipo-hero-subtitle">
          Contamos con un equipo de trabajo profesionalizado<br />
          en las diferentes áreas que nos competen para<br />
          brindar un servicio de calidad.
        </p>
        <button className="scroll-indicator" onClick={() => scrollToSection('directorio')}>
          <svg width="24" height="40" viewBox="0 0 24 40" fill="none">
            <rect x="1" y="1" width="22" height="38" rx="11" stroke="white" strokeWidth="2"/>
            <circle cx="12" cy="12" r="3" fill="white">
              <animate attributeName="cy" values="12;26;12" dur="2s" repeatCount="indefinite"/>
            </circle>
          </svg>
        </button>
      </section>

      {/* Departments */}
      {departamentos.map((dept, deptIndex) => (
        <section key={dept.id} id={dept.id} className="department-section">
          <h2 className="department-title">{dept.title}</h2>
          <div className={`department-carousel-wrapper${dept.members.length === 1 ? ' department-carousel-wrapper--single' : ''}`}>
            {dept.members.length > 1 && (
              <button
                type="button"
                className="carousel-btn carousel-btn-prev"
                aria-label="Miembro anterior"
                onClick={() => scrollDeptCarousel(dept.id, -1)}
              >
                ‹
              </button>
            )}
            <div
              className="members-grid members-carousel"
              ref={(el) => { if (el) deptScrollRefs.current[dept.id] = el; }}
            >
              {dept.members.map((member, memberIndex) => (
                <div key={memberIndex} className="member-card">
                  <div className="member-photo-wrapper">
                    <div 
                      className="member-photo"
                      style={{ backgroundImage: `url(${member.image})` }}
                    />
                  </div>
                  <h3 className="member-role">{member.role}</h3>
                  <p className="member-name">{member.name}</p>
                  <div className="member-decorative-icon">
                    <svg width="80" height="40" viewBox="0 0 80 40" fill="none">
                      <path d="M10 30 Q25 10 40 30 Q55 15 70 30" stroke="#c56a2e" strokeWidth="1" opacity="0.3"/>
                    </svg>
                  </div>
                </div>
              ))}
            </div>
            {dept.members.length > 1 && (
              <button
                type="button"
                className="carousel-btn carousel-btn-next"
                aria-label="Siguiente miembro"
                onClick={() => scrollDeptCarousel(dept.id, 1)}
              >
                ›
              </button>
            )}
          </div>
        </section>
      ))}

      {/* Back to top button */}
      <button className="back-to-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
        ↑
      </button>

      {/* Cart */}
      <Cart />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Equipo;
